import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

export const defaultState = {
  bankInformation: {
    list: [],
    listLoading: false,
  },
};

export const mutations = {
  BANK_INFORMATION_SET_LIST(state, list) {
    state.bankInformation.list = list;
  },
  BANK_INFORMATION_SET_LIST_LOADING(state, isLoading) {
    state.bankInformation.listLoading = isLoading;
  },
};

export const getters = {
  getBankInformationsList: state => state.bankInformation.list,
};

export const actions = {
  // eslint-disable-next-line no-unused-vars
  callPatBankInformationImportCSV({ dispatch }, file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/legacy/bank-information/import/csv`, formData, {
      timeout: 3 * 60 * 1000,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(result => result.data);
  },
  fetchPatBankInformationList({ commit }) {
    commit('BANK_INFORMATION_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/legacy/bank-information`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { bankInformations } = response;
          commit('BANK_INFORMATION_SET_LIST_LOADING', false);
          commit('BANK_INFORMATION_SET_LIST', bankInformations);
        });
      })
      .catch((error) => {
        commit('BANK_INFORMATION_SET_LIST_LOADING', false);
        commit('BANK_INFORMATION_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchPatBankInformationAll({ dispatch }) {
    dispatch('fetchPatBankInformationList');
  },
  createPatBankInformation({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/legacy/bank-information`, payload)
      .then((data) => {
        dispatch('fetchPatBankInformationAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  updatePatBankInformation({ dispatch }, payload) {
    const userId = payload.user_id;

    return axios.put(`${window.BASE_API.PAYOUT_AND_TAXES}/legacy/bank-information/${userId}`, payload)
      .then((data) => {
        dispatch('fetchPatBankInformationAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
};

const bankInformation = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default bankInformation;



// WEBPACK FOOTER //
// ./src/store/payout/bankInformation.js